// extracted by mini-css-extract-plugin
export var container = "_1g-0";
export var disabled = "_1g-4";
export var fullWidth = "_1g-3";
export var lined = "_1g-1";
export var selected = "_1g-5";
export var tab = "_1g-2";